"use client";

import dynamic from "next/dynamic";

const ShakaVideo = dynamic(() => import("../ShakaPlayer/index.js"), {
  ssr: true,
});

export default ShakaVideo;